import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import LegacyCheckoutPage from './LegacyCheckoutPage';
import SimpleCheckoutPage, { type SimpleCheckoutInfo } from './SimpleCheckoutPage';

type VersionInfo = { product_version?: string; error?: string } & Partial<SimpleCheckoutInfo>;

export default function CheckoutPage() {
  const { slug } = useParams<{ slug: string }>();
  const [info, setInfo] = useState<VersionInfo | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!slug) { setError('Link inválido.'); return; }
    fetch(`/api/checkout?action=info&slug=${encodeURIComponent(slug)}`)
      .then(async (response) => {
        const data = await response.json().catch(() => ({}));
        if (!response.ok) throw new Error(data.error || 'Pedido não encontrado');
        return data;
      })
      .then(setInfo)
      .catch((reason) => setError(reason.message));
  }, [slug]);

  if (error) return <div style={{ minHeight: '100vh', display: 'grid', placeItems: 'center', padding: 24, fontFamily: "'DM Sans',sans-serif", color: 'var(--text-muted)' }}>{error}</div>;
  if (!info || !slug) return <div style={{ minHeight: '100vh', display: 'grid', placeItems: 'center', fontFamily: "'DM Sans',sans-serif", color: 'var(--text-muted)' }}>Abrindo seu pedido…</div>;
  if (info.product_version === 'simple-v17') return <SimpleCheckoutPage info={info as SimpleCheckoutInfo} slug={slug} />;
  return <LegacyCheckoutPage />;
}
